import { ofetch } from "ofetch";
import {useApiAuth} from "@/composables/useApiAuth";

export default defineNuxtPlugin(async (_nuxtApp) => {

    // @ts-expect-error
    globalThis.$fetch = ofetch.create({
        async onRequest({ request, options }) {
            const { token } = useApiAuth();
            if (token.value !== null) {
                options.headers.set('Authorization', `Bearer ${token.value}`);
            }
        },
    });
});